import React, { PropsWithChildren, useCallback } from "react";
import styles from "./Checkbox.module.css";

export const Checkbox: React.FC<
  PropsWithChildren<{
    checked?: boolean;
    onChange: (value: boolean) => void;
    disabled?: boolean;
  }>
> = ({ checked, children, onChange, disabled }) => {
  const changeHandler: React.ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      onChange(e.target.checked);
    },
    [onChange],
  );
  return (
    <label
      className={styles.Checkbox + " " + (disabled ? styles.Disabled : "")}
    >
      <input type="checkbox" checked={checked} onChange={changeHandler} />
      <span />
      {children}
    </label>
  );
};
